import { PayoutMethodType } from 'containers/PayoutManagement/types';

export enum PayoutSubmissionTypeEnum {
  EMAIL = 'email',
  PHONE = 'phoneNumber',
}

export type UserPayoutDefaults = {
  email: string;
  phone: string;
  phoneCountryCode?: string;
  phoneCountryExtension?: string;
  phoneCountryName?: string;
};

/** Edit: active tab from saved payout only. Add: profile phone → Phone, else Email. */
export const getSubmissionType = (
  isEdit: boolean,
  payout?: PayoutMethodType | null,
  userDefaults?: UserPayoutDefaults,
): PayoutSubmissionTypeEnum => {
  if (isEdit) {
    return payout?.phoneNumber ? PayoutSubmissionTypeEnum.PHONE : PayoutSubmissionTypeEnum.EMAIL;
  }
  return userDefaults?.phone ? PayoutSubmissionTypeEnum.PHONE : PayoutSubmissionTypeEnum.EMAIL;
};

export const getInitialEmail = (
  isEdit: boolean,
  payout?: PayoutMethodType | null,
  userDefaults?: UserPayoutDefaults,
): string => (isEdit ? payout?.email || '' : userDefaults?.email || '');

export const getInitialPhone = (
  isEdit: boolean,
  payout?: PayoutMethodType | null,
  userDefaults?: UserPayoutDefaults,
): string => (isEdit ? payout?.phoneNumber || '' : userDefaults?.phone || '');

/** Values to apply when switching tabs — edit uses payout only; add uses profile defaults. */
export const getEmailForSubmissionType = (
  isEdit: boolean,
  payout?: PayoutMethodType | null,
  userDefaults?: UserPayoutDefaults,
): string => getInitialEmail(isEdit, payout, userDefaults);

export const getPhoneForSubmissionType = (
  isEdit: boolean,
  payout?: PayoutMethodType | null,
  userDefaults?: UserPayoutDefaults,
): string => getInitialPhone(isEdit, payout, userDefaults);
